import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {FetchClinicFilterModel} from '../models/fetch-clinic-filter.model';
import {FetchStatusFilterModel} from '../models/fetch-status-filter.model';
import {FetchUsersListModel} from '../models/fetch-users-list.model';
import {v1URL} from '../../../shared/constants/urls.constants';
import {CommonService} from '../../../shared/services/common.service';
import {
  RoleListResponse
} from '../../resources-hub/model/resource-details.model';
import {FetchGroupFilterModel} from "../models/fetch-group-filter.model";
import {EditProfileModel} from "../../../shared/models/edit-profile.model";
import {ResendInviteModel} from '../models/resend-invite.model';

@Injectable({
  providedIn: 'root',
})
export class ManageUsersService {
  onUserFilterChange = new BehaviorSubject<any>(null);
  fetchUsersListTrigger: Subject<any> = new Subject();

  constructor(private commonServices: CommonService) {
  }

  fetchClinicFilter(payload): Observable<FetchClinicFilterModel['response']> {
    const urlConfig = v1URL.filters.clients
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchGroupFilter(payload): Observable<FetchGroupFilterModel['response']> {
    const urlConfig = v1URL.filters.groups
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchStatusFilter(): Observable<FetchStatusFilterModel['response']> {
    const urlConfig = v1URL.filters["user-status"]
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url);
  }

  fetchUsersList(payload: FetchUsersListModel['request']): Observable<FetchUsersListModel['response']> {
    const urlConfig = v1URL.dashboard.users;
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchRoleList(): Observable<RoleListResponse['response']> {
    const urlConfig = v1URL.filters.roles
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url);
  }

  updateUserStatus(payload): Observable<RoleListResponse['response']> {
    const urlConfig = v1URL.user.profile.updateStatus
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  editProfile(payload): Observable<EditProfileModel["response"]> {
    const urlConfig = v1URL.user.profile.edit
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  assignUserToNewGroup(payload): Observable<any> {
    const urlConfig = v1URL.user.invite['send-invite']
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  resendInvite(payload: ResendInviteModel['request']): Observable<ResendInviteModel['response']> {
    const urlConfig = v1URL.user.invite.resendInvite
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }
}
